import L from 'leaflet'
import t from '@/libs/i18n'
import { timeToString } from '@/utils/time.utils'

import store from '@/store'
import axios from 'axios'
import { ref } from '@vue/composition-api'

const currentAddress=ref('')
export default function mapCommon() {

  /**
   * create marker
   * @param point
   * @param myPopup html code string that describe window info
   * @param icon
   * @returns {*}
   */
  const createMarker = (point, myPopup, icon) =>
  {
   
    
    return  L.marker([parseFloat(point.latitude), parseFloat(point.longitude)], {icon: icon})
     .on('click', function(e) {
      
        getPointAddress(e.latlng).then((res)=>{     
        Object.assign(point,{address:res.display_name})
        this.bindPopup(myPopup(point))
      })
    }).bindPopup(myPopup(point)) 
  }



  const getPointAddress=(point)=>{

    return new Promise((resolve, reject) => {
      axios.get(`https://nominatim.openstreetmap.org/reverse?format=jsonv2&lat=${point.lat.toFixed(5)}&lon=${point.lng.toFixed(5)}&accept-language=ar` )
         .then(res => resolve(res.data))
        .catch(reason => reject(reason.response))
    })
    
   
  }
  

  /**
   * create marker icon
   * @param device
   * @param withLabel
   * @returns {*}
   */
  const createIcon = (device, withLabel = false) =>
  {

    const label = withLabel ?
      ` <div class="m-label" style="color:${device.color ?? 'blue'}">${device.name}</div>` : ''

    let img;
    
    try {
       img = require('@/assets/markers/'+device.category+'/'+device.status+'.svg')
    } catch (e) {
      img = require('@/assets/markers/'+device.status+'.svg')
    }

    return L.divIcon({
      html: L.Util.template(`<div class="label-with-icon">${label}<div class="rotate-${device.course}"><img src="${img}" alt=""></div></div>`),
      iconSize    : [30, 40], })
  }




  const myPopup = (point) => {

    let $popup = `
      <div class="custom-popup" style="direction:${store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'}" >
      <div class="header">${point.name}</div>
      <div class="contract">${point.contract_name}</div>
      <table class="custom-popup-table">`

      $popup += `
      <tr>
        <td>${t.t('plate')}</td>
        <td >${point.plate}</td>
      </tr>`

      $popup += `
      <tr>
        <td>${ t.t('category') }</td>
        <td class="float-endx">${t.t(point.category)}</td>
      </tr>`

      $popup += `
      <tr>
        <td>${ t.t('MAP_DEVICE_TYPE') }</td>
        <td class="float-endx">${t.t(point.vehicle_type)}</td>
      </tr>`

      $popup += `
      <tr>
        <td>${ t.t('MAP_DEVICE_WEIGHT') }</td>
        <td class="float-endx">${point.weight}</td>
      </tr>`

      $popup += `
      <tr>
        <td>${ t.t('speed') }</td>
        <td class="float-endx">${point.speed+' '+t.t('km/h')}</td>
      </tr>`

      $popup += `
      <tr>
        <td>${ t.t('status') }</td>
        <td class="float-endx">${t.t(point.status)}</td>
      </tr> `

      $popup += `
      <tr>
        <td rowspan="2" >${ t.t('lastupdate') }</td>
        <td class="float-endx">${ point.devicetime }</td>
      </tr>
      <tr>
        <td class="float-endx">${ timeToString(point.devicetime) }</td>
      </tr>`

      if(point.status == 'idle' || point.status == 'stop'){
          $popup += `
          <tr>
            <td  rowspan="2" >${ t.t('MAP_STOP_TIME') }</td>
            <td class="float-endx">${ point.stopTime }</td>
          </tr>
          <tr>
            <td class="float-endx">${ timeToString(point.stopTime) }</td>
          </tr>`
      }

      // $popup += `
      // <tr>
      //   <td  rowspan="2" >${ t.t('MAP_LAST_MAP_UPDATE') }</td>
      //   <td class="float-endx">${ point.lastMapUpdate }</td>
      // </tr>
      // <tr>
      //   <td class="float-endx">${ timeToString(point.lastMapUpdate) }</td>
      // </tr>`

      $popup += `
      <tr>
        <td>${t.t('owner')}</td>
        <td>${point.owner_name}</td>
      </tr>`

      $popup += `
      <tr>
        <td>${t.t('MAP_DRIVER_NAME')}</td>
        <td>${point.driver_name}</td>
      </tr>`

      $popup += `
      <tr>
        <td>${t.t('MAP_DRIVER_PHONE')}</td>
        <td>${point.driver_phone_number}</td>
      </tr>`

      $popup += `
      <tr>
        <td>${t.t('location')}</td>
        <td> <a target="_blank"  href="https://maps.google.com/maps?q=${point.latitude+','+point.longitude}">${point.latitude+','+point.longitude}</a></td>
      </tr>`

      $popup += `
      <tr>
        <td>${t.t('road address')}</td>
        <td v-if="currentAddress.value!=''">${point.address}</td>
      </tr>`


      $popup += `</table>`

      if(Boolean(point.has_cam)){
        $popup += `
            <button 
                type="button" 
                onclick="document.getElementById('app').__vue__.$camStream.startLive({id:${point.id}, name:'${point.name}'})"
                class="leaflet-popup-button"
            >
            <div class="d-flex flex-wrap w-100 align-items-center justify-content-center">
              <p class="mx-1 my-0 ">${t.t('Cam Live')}</p>
              <img class="mx-1" style="width: 10%; height: 10%;" src="/cam/cam-icon.svg">
            </div>
                
            </button>`
      }
      


      $popup += `</div>`

      return $popup
      
  }


  return {
    createMarker,
    createIcon,
    myPopup
  }
}
